// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"b007560f","977":"afa2d680"}[chunkId] + ".chunk.js";
};